<template>
  <div class="is-flex is-justify-content-flex-end">
    <div class="pr-5 tag-size">
      <b-tag v-if="item.situacao == 1" type="is-success" size="is-medium">
        {{ $t("ativo") }}
      </b-tag>
      <b-tag v-else type="is-danger" size="is-medium">
        {{ $t("inativo") }}
      </b-tag>
    </div>
    <div v-if="canDelete">
      <b-button
        class="action-button"
        :type="item['situacao'] == 1 ? 'is-danger' : 'is-success'"
        :icon-right="item['situacao'] == 1 ? 'delete' : 'check'"
        @click="promptChangeSituacao()"
        v-tippy
        :title="$t(item['situacao'] == 1 ? 'desativar' : 'reativar')"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Service com metodo updateSituacao para fazer a requisição de mudar a situação
    service: {
      type: Object,
      required: true,
    },
    // Nome do registro na pagina
    record: {
      type: String,
      required: true,
    },
    // Item da tabela que está sendo passado
    item: {
      type: Object,
      required: true,
    },
    // Identificador desse item para a construção das menssagem
    identifier: {
      type: String,
      required: true,
    },
    // Permissões
    canDelete: {
      type: Boolean,
      default: false,
    },
    rotaIntegracao: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deletingItem: null,
      isLoading: false,
    };
  },
  methods: {
    promptChangeSituacao() {
      const message = this.$t(
        this.item.situacao == 1
          ? "msg-confirmacao-desativacao-n"
          : "msg-confirmacao-reativacao-n",
        { n: this.identifier }
      );

      this.$root.confirm({
        message,
        onConfirm: this.updateSituacao,
      });
    },
    updateSituacao() {
      // Faz uma cópia do item para não mutar a prop diretamente
      this.deletingItem = { ...this.item };
      this.deletingItem.situacao = this.deletingItem.situacao == 1 ? 0 : 1;

      this.isLoading = true;
      this.$store.commit("addLoader");

      this.service
        .updateSituacao(this.deletingItem)
        .then((r) => {
          if (r.status == 200) {
            const messageSuccess = this.$t(
              r.content.situacao != 1
                ? "msg-sucesso-ao-desativar"
                : "msg-sucesso-ao-reativar",
              { n: this.$t(this.record) }
            );

            this.$root.showMessage("success", messageSuccess, true, false);
          } else if (r.status == 500) {
            this.$root.showMessage("error", "Erro ao atualizar status.");
          }
        })
        .catch((e) => {
          console.error("Erro ao atualizar status.", e);

          const messageFail = this.$t(
            this.deletingItem && this.deletingItem.situacao != 1
              ? "msg-erro-ao-desativar"
              : "msg-erro-ao-reativar",
            { n: this.record }
          );

          this.$root.showMessage("error", messageFail, true, false);
        })
        .finally(() => {
          this.isLoading = false;
          this.deletingItem = null;
          this.$store.commit("removeLoader");
          this.$emit("loadData");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-size {
  .tag {
    width: 5rem;
    height: 3em;
  }
}
</style>
